import React from 'react';

export default function ErrorMessage({ message, onRetry }) {
  return (
    <div style={{
      padding: '20px',
      backgroundColor: '#fee',
      border: '1px solid #fcc',
      borderRadius: '8px',
      color: '#c33',
      textAlign: 'center'
    }}>
      <p style={{ margin: '0 0 10px 0', fontWeight: '500' }}>⚠️ {message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            padding: '8px 16px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Retry
        </button>
      )}
    </div>
  );
}
